import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash'

import {
  Table,
  Jumbotron,
  Button,
  ButtonToolbar,
  Tabs,
  Tab,
  Row,
  Grid,
  Col,
  Modal,
  Alert,
  Image,
  PanelGroup,
  Panel,
  ButtonGroup,
  FormControl,
  FormGroup,
  ControlLabel,
  Glyphicon,
  OverlayTrigger,
  Tooltip,
  Label
} from 'react-bootstrap';

import If from "../../utils/If"

import Loader from 'react-loader-advanced';

import '../../statics/css/table-exercises.css'
import '../../statics/css/mount-training.css'
import '../../statics/css/util.css'

import videoPlayerIcon from '../../statics/images/video_player.svg'

//DAO
import { exercisesByCategoryList, exercisesList } from '../../dao-firebase/exercise-firebase'
import { sectionsTrainingList, updateSectionFirebase, deleteSectionTraining } from '../../dao-firebase/section-daofirebae'
import { registerTraining, registerSectionFirebase, registerSectionsInTraining, deleteTraining, saveBkpTrainingTxt } from '../../dao-firebase/training-daofirebae'
import TableAllExercises from './table-all-exercises';
import TableDataExercises from './table-data-exercises';
import { formatJsDateToPt, difDates } from '../../utils/functions'

class MountTraining extends Component {

  constructor(props) {
    super(props);

    this.state = {

      form_name_training: '',
      form_description_training: '',

      time_training: '',

      name_section_training: '',
      description_section_training: '',
      sections_training: [],
      titleModalSection: "Cadastrar seção de treino",
      labelButtonModalSection: "Salvar",
      messageModalSection: '',
      edittingSection: undefined,

      showModalSelectExercises: false,
      sectionSelected: '',

      search_table_all_exercise: '',

      all_exercises: [],
      all_exercises_map: undefined,

      exercisesSelecteds: [],

      validateTraningMessage: '',

      //sections on firebase
      sectionsToSaveInTraining: [],
      bkpSectionsToUpdate: [],

      loadAll: true,

      deletingTraining: false,

      textTraining: {},

    };



  }

  componentDidMount() {

    this.loadTraining();
  }

  loadTraining() {

    exercisesList((response) => {

      let mapExercises = this.transformToMap(response);

      this.setState({
        all_exercises: response,
        all_exercises_map: mapExercises,
      }, () => {

        //Requisita o treino em alguns casos
        //1. Detalhar na lista de treinos, fluxo comum: this.props.location.state.training
        //2. Detalhar no modal de selação de treino do aluno: trainingToDetailModal
        //3. Detalhar um treino apenas para visualização
        if ((this.props.location && this.props.location.state && this.props.location.state.training) || this.props.trainingToDetailModal || this.props.trainingToLook) {

          let trainingToLoad = undefined;
          console.log(this.props.trainingToLook)
          if (this.props.trainingToDetailModal) {
            console.log("Treino modal")
            trainingToLoad = this.props.trainingToDetailModal;
          } else if (this.props.trainingToLook) {
            console.log("Entrou aqui treino vinculado")
            trainingToLoad = this.props.trainingToLook;
            console.log(trainingToLoad);
          } else {
            console.log("Detalhe do treino")
            trainingToLoad = this.props.location.state.training;
          }

          sectionsTrainingList(JSON.parse(localStorage.getItem("USER")).uid, trainingToLoad.id, (response, success) => {

            if (success) {

              //console.log(response);
              console.log("w");
              this.setState({
                form_name_training: trainingToLoad.data.name,
                form_description_training: trainingToLoad.data.description,
                time_training: trainingToLoad.time_training,
                sections_training: response,
                loadAll: false,
              })

            } else {

              console.log("q");
              this.setState({
                validateTraningMessage: response.message,
                loadAll: false,
              })
            }

          })
        } else {

          console.log("SEM LOAD AQUI")
          this.setState({
            loadAll: false,
          })
        }
        //console.log(this.state.all_exercises)
      })

    })
  }

  transformToMap(exercises) {

    var result = exercises.reduce(function (map, obj) {
      map[obj.id] = obj.data;
      return map;
    }, {});

    //console.log(result);

    return result;

  }

  componentWillMount() {


  }

  registerSection() {
    this.setState({
      name_section_training: '',
      description_section_training: '',
      messageModalSection: '',
      titleModalSection: "Cadastrar seção de treino",
      labelButtonModalSection: "Salvar",
      showModalRegisterSectionTraining: true,
    })
  }

  handleCloseRegisterSectionTraining() {
    this.setState({
      showModalRegisterSectionTraining: false,
    })
  }

  addSection() {

    if (this.state.name_section_training && this.state.name_section_training != '') {

      let section = {
        name: this.state.name_section_training,
        description: this.state.description_section_training,
        //indicando position da section no treino
        position_in_training: this.state.sections_training.length + 1,
        exercises: [],
      }

      this.state.sections_training.push(section);

      this.setState({
        sections_training: this.state.sections_training,
        showModalRegisterSectionTraining: false,
      })
    } else {
      this.setState({
        messageModalSection: "Insira um nome para a seção",
      })
    }
  }

  updateSection() {

    if (this.state.name_section_training && this.state.name_section_training != '') {

      let sectionToUpdate = this.state.sections_training[this.state.edittingSection];
      sectionToUpdate.name = this.state.name_section_training;
      sectionToUpdate.description = this.state.description_section_training;

      this.setState({
        sections_training: this.state.sections_training,
        showModalRegisterSectionTraining: false,
      })

    } else {
      this.setState({
        messageModalSection: "Insira um nome para a seção",
      })
    }
  }

  editSection(section, index) {
    this.setState({
      name_section_training: section.name,
      description_section_training: section.description,
      titleModalSection: "Editar seção de treino",
      labelButtonModalSection: "Atualizar",
      messageModalSection: '',
      showModalRegisterSectionTraining: true,
      edittingSection: index,
    })
  }

  renderSectionsTraining() {

    //Sort by position_in_section
    this.state.sections_training.sort((a, b) => (a.position_in_training > b.position_in_training) ? 1 : ((b.position_in_training > a.position_in_training) ? -1 : 0));

    return _.map(this.state.sections_training, (section, index) => {

      return (

        <If test={true}>
          <If test={section.description != ''}>
            <OverlayTrigger placement="left"
              overlay={
                <Tooltip id={index}>
                  <strong>{section.description}</strong>
                </Tooltip >
              }>
              <Button onClick={this.props.trainingToDetailModal || this.props.trainingToLook ? null : () => this.editSection(section, index)}>{section.name}</Button>
            </OverlayTrigger>
          </If>
          <If test={section.description == ''}>
            <Button onClick={this.props.trainingToDetailModal || this.props.trainingToLook ? null : () => this.editSection(section, index)}>{section.name}</Button>
          </If>
        </If>



      )
    })
  }

  onInputChange(target) {

    //console.log(target);

    let value = target.value;
    let name = target.name;

    if (name == "name_section_training") {
      this.setState({
        [name]: value.toUpperCase()
      });
    } else {
      this.setState({
        [name]: value
      }, () => {
        //console.log(name + ": " + value);
      });

    }

  }

  addExercise(event) {
    event.preventDefault();
    event.stopPropagation();

    //console.log("INDEX: " + event.target.id)
    this.setState({
      showModalSelectExercises: true,
      sectionSelected: event.target.id,
    })
  }

  handleCloseSelectExercises() {
    this.setState({
      showModalSelectExercises: false,
    })
  }

  updateExercisesSelecteds(node) {

    this.setState({
      exercisesSelecteds: node,
    })
  }

  addExercisesToSection() {

    if (this.state.sections_training[this.state.sectionSelected] != undefined) {

      for (let i = 0; i < this.state.exercisesSelecteds.length; i++) {
        //console.log("NODE " + i + ": " + this.state.exercisesSelecteds[i].id)

        //O objeto inteiro está no atributo ID do HTML element
        let auxExercise = JSON.parse(this.state.exercisesSelecteds[i].id);

        if (auxExercise != undefined) {
          //auxExercise é o objeto completo, nós precisamos apenas do seu uid
          let e_to_add = {
            id: auxExercise.id,
            data: {},
          }

          //Evitando erro de exercises null
          if (this.state.sections_training[this.state.sectionSelected].exercises == undefined) {
            this.state.sections_training[this.state.sectionSelected].exercises = [];
          }

          //inicializando infos para futuros campos de input
          e_to_add.data.infos = {
            series: '',
            repeatitions: '',
            charge: '',
            cadence: '',
            inter: '',
            obs: '',
            //A posicao de ordem do exercício é incializada com o tamanho do array de exercícios
            //ou seja, a última posição
            position_in_section: this.state.sections_training[this.state.sectionSelected].exercises.length,
            editing: true,
          }
          this.state.sections_training[this.state.sectionSelected].exercises.push(e_to_add);


        }
      }


    }

    this.state.exercisesSelecteds = [];

    this.setState({
      sections_training: this.state.sections_training,
      showModalSelectExercises: false,
    })

  }

  handleUpdateExercisesState(indexSection, updateExercisesSelecteds, isRemove) {

    //console.log("SECTIONS: " + this.state.sections_training);
    //console.table(updateExercisesSelecteds);

    this.state.sections_training[indexSection].exercises = updateExercisesSelecteds;
    //Reindexar os positions na section
    if (isRemove) {

      let sectionLoop = this.state.sections_training[indexSection]
      for (let i = 0; i < sectionLoop.exercises.length; i++) {
        sectionLoop.exercises[i].data.infos.position_in_section = i;
      }
    }

    this.setState({
      sections_training: this.state.sections_training,
    })
  }

  upSection(event, index) {

    event.preventDefault();
    event.stopPropagation();

    //Caso seja undefined quer dizer que foi de um botão desabilitado
    if (index) {
      //Reduzindo a posicao do exercício em questão (subindo o exercicio)
      this.state.sections_training[index].position_in_training = this.state.sections_training[index].position_in_training - 1;
      //O exercício de cima deve descer [index - 1], soma-se 1 no position dele
      this.state.sections_training[index - 1].position_in_training = this.state.sections_training[index - 1].position_in_training + 1;

      this.setState({
        sections_training: this.state.sections_training,
      })
    }
  }

  downSection(event, index) {

    event.preventDefault();
    event.stopPropagation();
    //console.log("INDEX DOWN: " + index);

    //Caso seja undefined quer dizer que foi de um botão desabilitado
    if (index == 0 || index) {
      //Aumentando a posicao do exercício em questão (descendo o exercicio)
      this.state.sections_training[index].position_in_training = this.state.sections_training[index].position_in_training + 1;
      //O exercício de cima deve descer [index + 1], subtrai-se 1 no position dele
      this.state.sections_training[index + 1].position_in_training = this.state.sections_training[index + 1].position_in_training - 1;

      this.setState({
        sections_training: this.state.sections_training,
      })
    }
  }

  renderAccordionTraining() {

    //Sort by position_in_section
    this.state.sections_training.sort((a, b) => (a.position_in_training > b.position_in_training) ? 1 : ((b.position_in_training > a.position_in_training) ? -1 : 0));

    let sizeSections = this.state.sections_training.length;

    return _.map(this.state.sections_training, (section, index) => {

      return (

        <Panel eventKey={(index + 1)} >
          <Panel.Heading>
            <Panel.Title toggle>
              <div className="title-accordion-exercise">
                <div className="position-label-accordion-section">

                  <If test={!this.props.trainingToDetailModal && !this.props.trainingToLook}>
                    <div className="position-buttons">
                      {/* Condição no onclick: só pode ser clicado o up caso não seja o primeiro item */}
                      <Glyphicon onClick={(index != 0 ? (e) => { this.upSection(e, index) } : (e) => { this.upSection(e, undefined) })} className={`action-exercise action-exercise-position up-data-exercise ${index == 0 ? 'disable-icon' : ''}`} glyph="arrow-up" />
                      {/* Condição no onclick: só pode ser clicado o down caso não seja o último item */}
                      <Glyphicon onClick={(index != (sizeSections - 1) ? (e) => { this.downSection(e, index) } : (e) => { this.downSection(e, undefined) })} className={`action-exercise action-exercise-position down-data-exercise ${index == (sizeSections - 1) ? 'disable-icon' : ''}`} glyph="arrow-down" />
                    </div>
                  </If>
                  <p className="text-bold color-primary">{section.name}
                    <If test={section.description && section.description != ''}>
                      <span className="description-section-accordion"> - {section.description}</span>
                    </If>
                  </p>
                </div>
                <If test={!this.props.trainingToDetailModal && !this.props.trainingToLook}>
                  <div className="actions-sections">
                    <p id={index} className="add-exercise-accordion" onClick={(e) => this.addExercise(e)}><Glyphicon glyph="plus" /> Adicionar exercícios</p>
                    <Glyphicon glyph="trash" onClick={(e) => this.handleShowConfirmRemoveSection(e, section, index)} />
                  </div>
                </If>

              </div>
            </Panel.Title>
          </Panel.Heading>
          <Panel.Body collapsible>
            <TableDataExercises customClass="center-heads" section={index} editable={this.props.trainingToDetailModal || this.props.trainingToLook ? false : true} allExercisesMap={this.state.all_exercises_map} exercises={this.state.sections_training[index].exercises} handleUpdateExercisesState={(exercisesUpdateds, isRemove) => this.handleUpdateExercisesState(index, exercisesUpdateds, isRemove)} />
          </Panel.Body>
        </Panel >


      )
    })

  }

  removeSectionAccordion() {

    this.state.sections_training.splice(this.state.indexSectionToRemove, 1);
    this.setState({
      sections_training: this.state.sections_training,
      showModalConfirmRemoveSection: false,
    })
  }

  validateTraining() {

    if (this.state.form_name_training == '') {
      this.setState({
        validateTraningMessage: "Insira um nome para o treino"
      })
      return false;
    } else if (this.state.sections_training.length == 0) {
      this.setState({
        validateTraningMessage: "O treino precisa ter pelo menos uma seção"
      })
      return false;
    }

    return true;
  }



  recursiveRegisterTraining(uidProfessor, indexSection, uidTraining, operation) {

    let sectionToSave = {};

    //Operação de registro de treino
    if (operation == "save") {
      sectionToSave = this.state.sections_training[indexSection]

    } else if (operation == "update") {
      //Operação de update de treino obtemos a section do bkup
      sectionToSave = this.state.bkpSectionsToUpdate[indexSection]
    }

    if (uidTraining) {
      sectionToSave.training = uidTraining;
    }

    //console.log("UID TRAINING: " + uidTraining)

    //console.log("SECTION TO SAVE: ");
    //console.log(sectionToSave);
    this.state.textTraining[sectionToSave.name] = {};
    //Colocando todos os editings dos exercises para false
    for (let k = 0; k < sectionToSave.exercises.length; k++) {
      //console.log(this.state.all_exercises_map[sectionToSave.exercises[k].id].name)
      this.state.textTraining[sectionToSave.name][this.state.all_exercises_map[sectionToSave.exercises[k].id].name] = sectionToSave.exercises[k].data.infos;
      sectionToSave.exercises[k].data.infos.editing = false;
      //console.log(sectionToSave.exercises[k]);
    }

    registerSectionFirebase(uidProfessor, sectionToSave, (response, uidTraining, success) => {

      //Caso a seção seja salva corretamente retorna-se um doc com o atributo training
      //Esse atributo será usado nas próximas sections
      if (success) {

        //verifica-se se chegou-se ao fim do número de seções
        //Testando caso de register e de update
        let stopOperations = false;
        if (operation == "save") {
          if ((indexSection + 1) == this.state.sections_training.length) {
            stopOperations = true;
          }
        } else if (operation == "update") {
          if ((indexSection + 1) == this.state.bkpSectionsToUpdate.length) {
            stopOperations = true;
          }
        }

        //Se stopOperations é true, chegamos ao fim das sections
        if (stopOperations) {

          //incluindo o último uid de section que foi salva
          this.state.sectionsToSaveInTraining.push(response.id);

          //console.log("NOVO NOME: " + this.state.form_name_training);

          registerSectionsInTraining(uidProfessor, uidTraining, {
            name: this.state.form_name_training,
            description: this.state.form_description_training,
            sections: this.state.sectionsToSaveInTraining,
          }, (response, success) => {

            if (success) {

              let m = "Treino salvo com sucesso!";
              if (operation == "update") {
                m = "Treino atualizado com sucesso!"
              }

              //console.log(this.state.textTraining);

              let textBkpTraining = {
                name: this.state.form_name_training,
                description: this.state.form_description_training,
                sections: this.state.sectionsToSaveInTraining,
                treino_text: this.state.textTraining,
              }
              saveBkpTrainingTxt(uidProfessor, textBkpTraining, () => {

              })

              console.log("x");
              this.setState({
                validateTraningMessage: m,
                messageAllStatus: "success",
                loadAll: false,
                requistionOn: false,
              })

              this.props.history.push({
                pathname: '/treino/trainingsList',
                state: { message: m }
              })

            } else {


              let m2 = "Falha ao salvar o treino: ";
              if (operation == "update") {
                m2 = "Falha ao atualizar o treino: "
              }

              console.log("y");
              this.setState({
                validateTraningMessage: m2 + response.message,
                messageAllStatus: "danger",
                loadAll: false,
                requistionOn: false,
              })

            }
          })

        } else {

          //console.log("SEÇÃO SALVA COM SUCESSO: " + response);
          //Com a resposta positiva adiciona o id da seção salva ao vetor de seções a serem salvas no training
          this.state.sectionsToSaveInTraining.push(response.id);
          this.setState({
            sectionsToSaveInTraining: this.state.sectionsToSaveInTraining,
          })

          //Continua-se a salvar as sections
          this.recursiveRegisterTraining(uidProfessor, indexSection + 1, uidTraining, operation);
        }

      } else {

        console.log("z");
        this.setState({
          validateTraningMessage: "Falha ao salvar seção de treino: " + response.message,
          messageAllStatus: "danger",
          loadAll: false,
          requistionOn: false,
        })

      }

    })


  }

  saveTraining() {

    this.setState({
      loadAll: true,
      validateTraningMessage: "",
      sectionsToSaveInTraining: [],
    })

    if (this.validateTraining()) {

      let uidProfessor = JSON.parse(localStorage.getItem("USER")).uid;

      //console.log('Passando pelo save');

      //Caso haja um treino devemos limpar o uidtraining das sections, para evitar duplicata
      if (this.props.location && this.props.location.state && this.props.location.state.training) {
        for (let x = 0; x < this.state.sections_training.length; x++) {
          let sectionLoop = this.state.sections_training[x];
          sectionLoop.training = undefined;
        }
      }

      //primeira chamada para salvar seção, na primeira chamada cria-se o uidTraining, por isso é enviado como undefined
      this.recursiveRegisterTraining(uidProfessor, 0, undefined, "save");

    }
  }

  recursiveDeleteSectionTraining(uidProfessor, sections, indexSection) {

    //Sections do training é um array de uids de sections
    let uidSectionToDelete = sections[indexSection];

    //console.log("DELETANDO: " + uidSectionToDelete)
    //console.log("SECTIONS: " + sections)

    deleteSectionTraining(uidProfessor, uidSectionToDelete, (response, success) => {

      if (success) {

        //console.log("DELETADO COM SUCESSO: " + uidSectionToDelete)

        //Caso indexSection + 1 seja = ao tamanho do array, chegamos ao fim dos uids
        if ((indexSection + 1) == sections.length) {

          this.setState({
            requistionOn: true,
          })

          //Testa-se se foi uma real deleção de treino
          if (this.state.deletingTraining) {

            deleteTraining(JSON.parse(localStorage.getItem("USER")).uid, this.props.location.state.training, (success) => {
              if (success) {

                alert("Treino excluído com sucesso")

                this.props.history.push('/treino/trainingsList')

              } else {
                this.setState({
                  messageAll: "Falha ao deletar treino!",
                  messageAllStatus: "warning",
                })

                setTimeout(() => {

                  if (this.state.messageAll == "Falha ao deletar treino!") {
                    this.setState({
                      messageAll: '',
                    });
                  }
                }, 5000);

                window.scrollTo(0, 0);
              }
            });

          } else {
            this.recursiveRegisterTraining(uidProfessor, 0, this.props.location.state.training.id, "update");
          }


        } else {

          //console.log("SECTIONS RESTANTES: ")
          //console.log(sections);
          //Caso ainda hajam uids chamamos recursivamente a próxima deleção
          this.recursiveDeleteSectionTraining(uidProfessor, sections, indexSection + 1);
        }


      } else {
        console.log("h");
        this.setState({
          validateTraningMessage: "Falha ao deletar seção de treino: " + response.message,
          messageAllStatus: "danger",
          loadAll: false,
        })
      }

    })
  }

  updateTraining() {

    this.setState({
      loadAll: true,
      sectionsToSaveInTraining: [],
    })

    //Deleta-se as seções para a criação das novas
    //Manda-se o indexSection = 0, para inciar a recurssão

    //Fazendo bkp das sections a serem salvas novamente no training
    this.state.bkpSectionsToUpdate = [];
    for (let i = 0; i < this.state.sections_training.length; i++) {
      this.state.bkpSectionsToUpdate.push(this.state.sections_training[i]);
    }

    this.setState({
      bkpSectionsToUpdate: this.state.bkpSectionsToUpdate,
    }, () => {

      this.recursiveDeleteSectionTraining(JSON.parse(localStorage.getItem("USER")).uid, this.props.location.state.training.data.sections, 0)

    })

  }

  changeUserTraining() {
    this.props.changeUserTraining();
  }

  changeTimeTraining() {
    this.props.changeTimeTraining();
  }

  convertDate(date) {

    let convertedDate = new Date(date * 1000).toLocaleDateString("pt-BR");

    return convertedDate;
  }

  handleShowConfirmRemoveTraining() {

    this.setState({
      showModalConfirmRemoveTraining: true,
    })
  }

  handleCloseConfirmRemoveSection() {

    this.setState({
      showModalConfirmRemoveTraining: false,
    })
  }

  handleShowConfirmRemoveSection(event, section, index) {

    event.preventDefault();
    event.stopPropagation();

    this.setState({
      sectionToRemove: section,
      indexSectionToRemove: index,
      showModalConfirmRemoveSection: true,
    })
  }

  handleCloseConfirmRemoveSection() {

    this.setState({
      showModalConfirmRemoveSection: false,
    })
  }

  deleteTrainingDb() {

    this.setState({
      loadAll: true,
      showModalConfirmRemoveTraining: false,
      deletingTraining: true,
    }, () => {
      this.recursiveDeleteSectionTraining(JSON.parse(localStorage.getItem("USER")).uid, this.props.location.state.training.data.sections, 0)
    })

  }


  render() {

    return (
      <div className="mount-training-page">

        <Loader show={this.state.loadAll} message={<div className="loader"></div>}
          backgroundStyle={{ backgroundColor: 'none' }}
          foregroundStyle={{ color: 'white', backgroundColor: 'rgb(255,255,255,0.7)' }}>

          <Grid>
            <Row className="flex-row">
              <Col xs={12} md={12} className="no-p-left no-p-right text-left">

                {this.state.validateTraningMessage != '' ?
                  <Alert bsStyle={!this.state.messageAllStatus || this.state.messageAllStatus == '' ? 'warning' : this.state.messageAllStatus}>
                    <p>{this.state.validateTraningMessage}</p>
                  </Alert>
                  : null}

                <If test={!this.props.trainingToDetailModal && !this.props.trainingToLook}>
                  <div className="label-more-button-top">
                    <h1 className="label-table">Treino</h1>
                    <div className="actions-submit-training">
                      {/* Caso seja a amostragem do treino na tela do aluno não exibimos esses botões */}

                      {/* Detalhando um treino existente */}
                      <If test={this.props.location && this.props.location.state && this.props.location.state.training}>
                        <div className="btns-training-saved">
                          <Button className="update-button-training" bsStyle="success" onClick={() => this.updateTraining()}>Atualizar treino</Button>
                          <Button className="update-button-training" bsStyle="danger" onClick={() => this.handleShowConfirmRemoveTraining()}>Deletar treino</Button>
                        </div>
                      </If>
                      <Button bsStyle="primary" onClick={() => this.saveTraining()}>Salvar treino</Button>

                    </div>
                  </div>
                </If>

                <div className={`${this.props.trainingToLook ? 'flex-row-name-change-training' : ''}`}>
                  <FormGroup controlId="formControlsNameTraining" className="form-group-name">
                    <ControlLabel>Nome</ControlLabel>
                    <If test={!this.props.trainingToDetailModal && !this.props.trainingToLook}>
                      <FormControl
                        name="form_name_training"
                        type="text"
                        value={this.state.form_name_training}
                        placeholder="Insira o nome"
                        onChange={(event) => this.onInputChange(event.target)} />
                    </If>
                    <If test={this.props.trainingToDetailModal}>
                      <p>{this.state.form_name_training}</p>
                    </If>
                    <If test={this.props.trainingToLook}>
                      <p>{this.state.form_name_training}</p>
                    </If>
                  </FormGroup>

                  <If test={this.props.trainingToLook}>
                    <div className="change-traning-div">
                      <p className="secondaryFontColor">Atualizado em {this.props.trainingToLook ? this.convertDate(this.props.trainingToLook.date_update_training.seconds) : null}</p>
                      <Button bsStyle={`${
                        (
                          this.props.trainingToLook
                          &&
                          (
                            !this.props.trainingToLook.training_time
                            ||
                            (difDates(new Date, formatJsDateToPt(this.props.trainingToLook.training_time)) == null || difDates(new Date, formatJsDateToPt(this.props.trainingToLook.training_time)) <= 0)
                          )
                        )
                          ?
                          'danger'
                          :
                          (
                            this.props.trainingToLook && this.props.trainingToLook.training_time && difDates(new Date, formatJsDateToPt(this.props.trainingToLook.training_time)) > 10
                              ?
                              'success'
                              :
                              'warning'
                          )
                        }`} onClick={() => this.changeTimeTraining()}>Vencimento: {(this.props.trainingToLook && this.props.trainingToLook.training_time) ? formatJsDateToPt(this.props.trainingToLook.training_time) : "Não informado"}</Button>
                      <p></p>
                      <Button bsStyle="info" onClick={() => this.changeUserTraining()}>Trocar treino</Button>
                    </div>
                  </If>
                </div>

                <FormGroup controlId="formControlsDescriptionTraining">
                  <ControlLabel>Descrição</ControlLabel>
                  <If test={!this.props.trainingToDetailModal && !this.props.trainingToLook}>
                    <FormControl
                      rows="5"
                      componentClass="textarea"
                      name="form_description_training"
                      type="text"
                      className="textarea-fixed"
                      value={this.state.form_description_training}
                      placeholder="Insira a descrição"
                      onChange={(event) => this.onInputChange(event.target)} />
                  </If>
                  <If test={this.props.trainingToDetailModal}>
                    <p>{this.state.form_description_training}</p>
                  </If>
                  <If test={this.props.trainingToLook}>
                    <p>{this.state.form_description_training}</p>
                  </If>
                </FormGroup>

                <FormGroup>
                  <ControlLabel>Seções do treino</ControlLabel>
                  <div>

                    <If test={this.state.sections_training.length > 0}>
                      <ButtonToolbar className="toolbar-sections">
                        {this.renderSectionsTraining()}
                      </ButtonToolbar>
                    </If>

                    <If test={!this.props.trainingToDetailModal && !this.props.trainingToLook}>

                      <Button className="btn-add-section-training" bsStyle="success" onClick={() => this.registerSection()}><Glyphicon glyph="plus" /> Adicionar seção</Button>
                    </If>
                  </div>
                </FormGroup>

                {/* <ControlLabel className="label-table">Exercícios</ControlLabel> */}
                {/* <TableExercises customClass="table-mount-training" /> */}

                <If test={this.state.sections_training.length > 0}>

                  <ControlLabel>Exercícios</ControlLabel>
                  <PanelGroup accordion id="accordion-example">

                    {this.renderAccordionTraining()}

                  </PanelGroup>
                </If>

              </Col>
              {/* <Col xs={6} md={6} className=" no-p-right">



            </Col> */}
            </Row>
          </Grid>
        </Loader>
        <Modal show={this.state.showModalRegisterSectionTraining}
          bsSize="small">
          <Loader show={this.state.load} message={<div className="loader"></div>}
            backgroundStyle={{ backgroundColor: 'none' }}
            foregroundStyle={{ color: 'white', backgroundColor: 'rgb(255,255,255,0.7)' }}>
            <Modal.Header>
              <Modal.Title>{this.state.titleModalSection}</Modal.Title>
            </Modal.Header>

            <Modal.Body>

              {this.state.messageModalSection != '' ?
                <Alert bsStyle="warning">
                  <p>{this.state.messageModalSection}</p>
                </Alert>
                : null}

              <FormGroup>
                <ControlLabel>Nome da seção</ControlLabel>
                <FormControl
                  name="name_section_training"
                  type="text"
                  value={this.state.name_section_training}
                  placeholder="Insira o nome"
                  onChange={(event) => this.onInputChange(event.target)} />
              </FormGroup>

              <FormGroup>
                <ControlLabel>Descrição da seção</ControlLabel>
                <FormControl
                  rows="3"
                  componentClass="textarea"
                  name="description_section_training"
                  type="text"
                  className="textarea-fixed"
                  value={this.state.description_section_training}
                  placeholder="Insira a descrição"
                  onChange={(event) => this.onInputChange(event.target)} />
              </FormGroup>
            </Modal.Body>

            <Modal.Footer>
              <Button onClick={() => this.handleCloseRegisterSectionTraining()}>Fechar</Button>
              <Button bsStyle="primary" onClick={this.state.labelButtonModalSection == "Salvar" ? () => this.addSection() : () => this.updateSection()}>{this.state.labelButtonModalSection}</Button>
            </Modal.Footer>

          </Loader>
        </Modal>

        <Modal show={this.state.showModalSelectExercises}

          dialogClassName="no-padding all-exercises-modal">

          <Modal.Header>
            <Modal.Title>
              <Grid>
                <Row className="flex-row">
                  <Col xs={6} md={6} className="no-p-left no-p-right text-left">
                    <p className="no-m-bottom">Exercícios [{this.state.sections_training[this.state.sectionSelected] ?
                      this.state.sections_training[this.state.sectionSelected].name
                      : null}]
                      </p>
                  </Col>
                  <Col xs={6} md={6} className="no-p-left no-p-right text-left">
                    <FormControl
                      name="search_table_all_exercise"
                      type="text"
                      value={this.state.search_table_all_exercise}
                      placeholder="Pesquisar exercício"
                      onChange={(event) => this.onInputChange(event.target)} />
                  </Col>
                </Row>
              </Grid>


            </Modal.Title>
          </Modal.Header>

          <Modal.Body>

            <TableAllExercises customClass="no-video clickable"
              exercises={this.state.all_exercises}
              search={this.state.search_table_all_exercise}
              sections={this.state.sections_training}
              handleUpdateExercisesSelected={(node) => this.updateExercisesSelecteds(node)} />

          </Modal.Body>

          <Modal.Footer>
            <Button onClick={() => this.handleCloseSelectExercises()}>Fechar</Button>
            <Button bsStyle="primary" onClick={() => this.addExercisesToSection()}>Adicionar [ {this.state.exercisesSelecteds.length} ]</Button>
          </Modal.Footer>

        </Modal>

        <Modal show={this.state.showModalConfirmRemoveSection}
          bsSize="small">

          <Modal.Header>
            <Modal.Title>Remover seção</Modal.Title>
          </Modal.Header>

          <Modal.Body className="text-center">
            <h4>Deseja realmente remover a seção?</h4>
            <h2><b>{this.state.sectionToRemove ? this.state.sectionToRemove.name : null}</b></h2>

          </Modal.Body>

          <Modal.Footer>
            <Button onClick={() => this.handleCloseConfirmRemoveSection()}>Fechar</Button>
            <Button bsStyle="danger" onClick={() => this.removeSectionAccordion(this.state.sectionToRemove)}>Excluir</Button>

          </Modal.Footer>

        </Modal>

        <Modal show={this.state.showModalConfirmRemoveTraining}
          bsSize="small">

          <Modal.Header>
            <Modal.Title>Excluir treino</Modal.Title>
          </Modal.Header>

          <Modal.Body className="text-center">
            <h4>Deseja realmente excluir o treino?</h4>
            <h2><b>{this.props.location && this.props.location.state && this.props.location.state.training ? this.props.location.state.training.data.name : null}</b></h2>

          </Modal.Body>

          <Modal.Footer>
            <Button onClick={() => this.handleCloseConfirmRemoveTraining()}>Fechar</Button>
            <Button bsStyle="danger" onClick={() => this.deleteTrainingDb()}>Excluir</Button>

          </Modal.Footer>

        </Modal>
      </div >
    );
  }
}

export default MountTraining;



// WEBPACK FOOTER //
// src/components/treinos/mount-training.js